export enum EChangeCutOffTime {
  LIST = 'list',
  ADD = 'add',
  EDIT = 'edit',
}